import React from 'react';
import styled from 'styled-components';

import { Container, Typography } from '@material-ui/core/';

import CardWrapper from '../components/common/CardWrapper';

const Root = styled(Container)`
	h2,
	h3,
	h4,
	p {
		max-width: 700px;
	}

	h2,
	h3 {
		margin: 40px 0 10px 0;
	}

	h1 {
		font-size: 48px;
	}

	h2 {
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
	}

	h3 {
		font-size: 18px;
		font-weight: bold;
	}

	h4 {
		font-size: 16px;
		text-transform: uppercase;
	}

	ul {
		font-size: 16px;
		padding-left: 20px;
	}

	/* margin-top: 64px;

	.containerImprint {
		> p:first-of-type {
			font-size: 1.15rem;
			margin-top: 32px;
			font-weight: 600;
		}

		p {
			font-size: 1rem;
		}

		a {
			color: #4097a3;
		}
	} */
`;

const PagePrivacy = () => (
	<Root maxWidth="lg">
		<CardWrapper>
			<Typography variant="h1">
				Datenschutzerklärung und Widerrufsbelehrung
			</Typography>
			<Typography variant="h2">
				Erklärung der be.storaged GmbH zum Datenschutz:
			</Typography>
			<Typography>
				Datenschutz und Datensicherheit für Kunden und Nutzer haben für
				be.storaged eine hohe Priorität. Der Schutz Ihrer personenbezogenen Daten
				in allen unseren Geschäftsprozessen ist uns daher ein besonderes Anliegen.
				Diese Erklärung zum Datenschutz erläutert, welche Informationen auf
				unserer Website durch Ihren Besuch erfasst und wie diese Informationen
				genutzt werden. Die Erklärung gilt jedoch nicht für Websites anderer
				Unternehmen, die einen Link zu dieser Website der be.storaged GmbH
				enthalten oder zu denen unsere Website Links gelegt hat.
			</Typography>
			<Typography variant="h3">be.storaged GmbH</Typography>
			<Typography>Tirpitzstraße 39</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography>E-Mail: info@be-storaged.com</Typography>
			<Typography>
				<a
					href="http://www.be-storaged.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.be-storaged.com
				</a>
			</Typography>
			<Typography variant="h2">
				Datenverarbeitung beim Besuch der Webseite
			</Typography>
			<Typography variant="h4">
				Bereitstellung der Webseite und Erstellung von Logfiles
			</Typography>
			<Typography>
				Wenn Sie unsere Website besuchen, erfasst be.storaged automatisiert Daten
				und Informationen von Ihrem Rechner bzw. Endgerät. Folgende Daten werden
				hierbei erhoben:
			</Typography>
			<ul>
				<li>IP-Adresse oder den Domain-Name des anfragenden Rechners</li>
				<li>Datum und Uhrzeit des Abrufs</li>
				<li>Abgerufene Webseiten</li>
				<li>ggf. Betriebssystem und Browsersoftware Ihres Rechners</li>
				<li>Webseite, von der Sie die be.storaged besuchen.</li>
			</ul>
			<Typography>
				Die Daten werden zur Sicherstellung unserer Systemsicherheit erhoben und
				verarbeitet. Die IP-Adresse wird hierbei spätestens nach 7 Tagen gelöscht.
				Eine weitergehende Verarbeitung der Daten in anonymisierter Form behält
				sich be.storaged vor.
			</Typography>
			<Typography>
				Die Datenverarbeitung erfolgt gem. Art. 6 Abs. 1 lit. f
				Datenschutz-Grundverordnung (DS-GVO)
			</Typography>
			<Typography>
				{' '}
				<a
					href="http://www.be-storaged.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.be-storaged.com
				</a>
			</Typography>
			<Typography variant="h2">Kontaktaufnahme</Typography>
			<Typography>
				Sofern Sie ein Anliegen oder einen Wunsch haben, können Sie über unser
				Kontaktformular mit uns Kontakt aufzunehmen. Folgende Daten werden von
				be.storaged im Rahmen der Kontaktaufnahme erhoben: Anrede, Vorname,
				Nachname, Adresse, E-Mail-Adresse, Kundennummer (sofern Kunde) und das
				Anliegen. Die Daten werden zu Zwecken der Bearbeitung und Beantwortung
				Ihres Anliegens verarbeitet. Die Datenlöschung erfolgt in Abhängigkeit
				Ihres Anliegens. Die Datenverarbeitung erfolgt gem. Art. 6 Abs. 1 lit. f
				DS-GVO.
			</Typography>
			<Typography variant="h2">Newsletter</Typography>
			<Typography>
				Sofern Sie Kunde von be.storaged sind und im Rahmen des
				Kundenverhältnisses Ihre E-Mail-Adresse hinterlegt haben, kann diese in
				der Folge durch uns für den Versand eines Newsletters verwendet werden.
				Ferner haben Sie die Möglichkeit, sich für den kostenlosen Newsletter auf
				unserer Website anzumelden. Folgende Daten werden bei der Anmeldung über
				unsere Website erhoben: Pflichtfelder: E-Mail-Adresse, Wunschthema, Datum
				und Uhrzeit der Anmeldung Freiwillige Angaben: Anrede, Vorname, Nachname,
				PLZ, Geburtsdatum, Kundennummer Die Pflichtangaben benötigen wir zum
				Versand des Newsletters. Den Zweck der freiwilligen Angaben können Sie bei
				der Anmeldung den Info-Feldern entnehmen. Die Daten werden gelöscht,
				sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr
				erforderlich sind. Die Datenverarbeitung erfolgt gegenüber Kunden gem. § 7
				Abs. 3 UWG. Bei Interessenten erfolgt die Datenverarbeitung gem. Art. 6
				Abs. 1 lit. a DS-GVO Sie haben die Möglichkeit, dem Versand des
				Newsletters jederzeit zu widersprechen. Zu diesem Zweck befindet sich in
				jedem Newsletter ein entsprechender Link.
			</Typography>
			<Typography variant="h2">Online-Bewerbung</Typography>
			<Typography>
				Sofern Sie sich bei be.storaged bewerben, verarbeiten wir Ihre
				personenbezogenen Daten zur Bearbeitung Ihrer Bewerbung. Ihre
				Bewerberdaten werden nur zu diesem Zweck und im Rahmen der gesetzlichen
				Bestimmungen verwendet. Ihre Daten werden hierbei vertraulich behandelt.
				Wir erfassen nur solche personenbezogenen Daten von Ihnen, die für das
				Bewerbungsverfahren erforderlich sind. Ihre Daten werden der Führungskraft
				der jeweiligen Konzerngesellschaft zur Verfügung gestellt. Folgende Daten
				werden bei Ihrer Bewerbung von be.storaged erhoben: Pflichtfelder: Anrede,
				Vorname. Nachname, E-Mail-Adresse, Passwort, PLZ, Telefonnummer
				Freiwillige Angaben: Geburtsdatum, Adresse, alternative Telefonnummer,
				Vorliegen einer Schwerbehinderung, eingereichte Bewerbungsunterlagen Ihre
				Daten werden spätestens drei Monate nach Abschluss des
				Bewerbungsverfahrens gelöscht. Unabhängig davon, können Sie im Rahmen
				Ihrer Online-Bewerbung jederzeit Ihre Daten sowie die beigefügten Anhänge
				(wie z.B. Lebenslauf) einsehen, bearbeiten oder löschen. Verantwortlicher
				im Sinne des Art. 4 DS-GVO ist die in der jeweiligen Stelleanzeige
				genannte Konzerngesellschaft. Bei Initiativbewerbungen ist die
				Konzerngesellschaft verantwortliche Stelle, bei der Sie sich initiativ
				bewerben. Die Datenverarbeitung erfolgt gem. Art. 6 Abs. 1 lit. f DS-GVO.
			</Typography>
			<Typography variant="h2">
				Cookies und Interessensbezogene Werbung (Retargeting)
			</Typography>
			<Typography>
				An einigen Stellen der Website verwendet be.storaged die sogenannte
				Cookie-Technologie, um einen vorbildlichen Kundenservice zu leisten,
				bequemen Zugriff auf unsere Produkte und Dienstleistungen zu geben und
				einen größeren Leistungsumfang anzubieten. Cookies sind kleine
				Textdateien, die von einem Webserver generiert und mittels des genutzten
				Webbrowsers auf Ihrem Computer speichert werden. Die meisten von
				be.storaged eingesetzten Cookies werden nach dem Ende der Session wieder
				gelöscht. Einige Cookies verbleiben auch nach Beendigung der Session auf
				Ihrem PC und ermöglichen uns somit, Ihren PC anhand der im Cookie
				gespeicherten Daten (Besuch unserer Website einschl. Datum und Uhrzeit,
				Browsertyp, Betriebssystem, Produkte, die Sie auf unserer Website
				angesehen haben) beim nächsten Besuch wieder zu erkennen (ID-Cookies).
				Anhand der in den Cookies gespeicherten Informationen ist eine persönliche
				Identifizierung nicht möglich. Die Datenverarbeitung erfolgt gem. Art. 6
				Abs. 1 lit. f DS-GVO. Ferner werden beim Besuch unserer Website
				Third-Party-Cookies zu Zwecken der interessensbezogenen Werbung
				(Retargeting) und der Webanalyse auf Ihrem Rechner gespeichert. Beim
				Retargeting wird Ihnen beim Besuch unserer Website ein Third-Party-Cookie
				gesetzt. Der Cookie enthält pseudonymisierte Informationen über Ihr
				Nutzerverhalten auf unserer Website. Im Rahmen eines Werbenetzwerkes kann
				Ihnen so nutzungsbasierte Online-Werbung angezeigt werden. Wenn Sie keine
				nutzungsbasierten Werbeeinblendungen mehr erhalten möchten, können Sie die
				Datenverarbeitung unter den folgenden Links deaktivieren: Google
			</Typography>
			<Typography>
				Die Cookies werden für eine Dauer von 14 Monaten gespeichert. Sie können
				der Datenverarbeitung hier widersprechen. Die Datenverarbeitung erfolgt
				gem. Art. 6 Abs. 1 lit. a DS-GVO.
			</Typography>
			<Typography variant="h2">Google Analytics</Typography>
			<Typography>
				Diese Website benutzt Google Analytics, einen Webanalysedienst der Google
				Inc. (Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA 94043-1351,
				USA). Google Analytics verwendet sog. „Cookies“, Textdateien, die auf
				Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der
				Website durch Sie ermöglichen. Die durch den Cookie erzeugten
				Informationen über Ihre Benutzung dieser Website werden in der Regel an
				einen Server von Google in den USA übertragen und dort gespeichert. Wir
				verwenden für die Webanalyse über Google Analytics den Zusatz
				„gat._anonymizelp“. Durch diesen Zusatz wird die IP-Adresse des
				Internetanschlusses von Google gekürzt bzw. anonymisiert, wenn der Zugriff
				auf unsere Website aus einem Mitgliedstaaten der Europäischen Union oder
				in anderen Vertragsstaaten des Abkommens über den Europäischen
				Wirtschaftsraum erfolgt. Nur in Ausnahmefällen wird die volle IP-Adresse
				an einen Server von Google in den USA übertragen und dort gekürzt. Die
				IP-Adresse wird in diesem Zusammenhang nicht mit anderen Daten von Google
				zusammengeführt. Google wird diese Informationen im Auftrag des
				Website-Betreibers auswerten, um Berichte über die Websiteaktivitäten zu
				erstellen und auf deren Basis weitere verbundene Dienstleistungen
				gegenüber dem Website-Betreiber zu erbringen. Die Cookies werden
				automatisiert nach einer Dauer von 14 Monaten gelöscht. Die berechtigten
				Interessen an der Datenverarbeitung bestehen im Wesentlichen in der
				Optimierung der Website. Die Datenverarbeitung für den Einsatz von Google
				Analytics erfolgt gem. Art. 6 Abs. 1 lit. a DS-GVO.
			</Typography>
			<Typography>
				Sie können die Speicherung der Cookies durch eine entsprechende
				Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch
				darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
				Funktionen dieser Website vollumfänglich werden nutzen können. Sie können
				darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre
				Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google
				sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das
				unter dem folgenden Link{' '}
				<a
					href="http://tools.google.com/dlpage/gaoptout?hl=de"
					target="_blank"
					rel="noopener noreferrer"
				>
					(http://tools.google.com/dlpage/gaoptout?hl=de)
				</a>
				verfügbare Browser-Plugin herunterladen und installieren.
			</Typography>
			<Typography>
				Alternativ zum Browser Add-On können Sie die Erfassung Ihrer Daten durch
				Google Analytics verhindern, indem Sie diesen Link anklicken: Google
				Analytics deaktivieren Nähere Informationen und die geltenden
				Datenschutzbestimmungen von Google finden Sie unter
				https://www.google.de/intl/de/policies/privacy/ bzw.
				http://www.google.com/analytics/terms/de.html.
			</Typography>
			<Typography variant="h2">Google AdWords</Typography>
			<Typography>
				Sofern Sie über eine Google-Anzeige auf unsere Website gelangt sind, wird
				Ihnen von Google AdWords ein Cookie auf Ihrem Rechnergesetzt. Dieser
				Cookie verliert nach 30 Tagen seine Gültigkeit und es ist auf Grund der
				gespeicherten Informationen nicht möglich, Rückschlüsse zu Ihrer Person
				herzustellen. Wir nutzen die Informationen des Conversion-Cookie um
				statistische Auswertungen bezüglich der Konventionsrate zu erhalten. Das
				bedeutet, dass wir erfahren, wie viele Nutzer von einer Google-Anzeige auf
				unsere Website gekommen sind und innerhalb von 30 Tagen eine Bestellung
				ausgelöst haben. Die Datenverarbeitung für den Einsatz von Google AdWords
				erfolgt gem. Art. 6 Abs. 1 lit. a DS-GVO. Sie können der
				interessenbezogenen Werbung durch Google widersprechen. Hierzu müssen Sie
				von jedem der von ihr genutzten Internetbrowser aus den Link
				https://www.google.de/settings/ads aufrufen und dort die gewünschten
				Einstellungen vornehmen. BING ADS UNIVERSAL EVENT TRACKING (UET) Wir
				setzen auf unserer Seite das Conversion Tracking „Bing Ads“ der Microsoft
				Corporation (One Microsoft Way, Redmond, WA 98052-6399, USA) ein. Wenn Sie
				von einer Microsoft Bing Anzeige auf unsere Website gelangen, wird Ihnen
				von Microsoft Bing Ads ein Cookie gesetzt. Auf unserer Website ist ein
				UET-Tag integriert. Beim UET-Tag handelt es sich um einen Code, der in
				Verbindung mit dem Cookie Daten über die Nutzung der Website speichert.
				Microsoft und wir können auf diese Weise erfahren, wie lange die
				Verweildauer auf der Website war, welche Bereiche der Website abgerufen
				wurden und über welche Anzeige die Nutzer auf unsere Website gelangt sind.
				Diese Informationen ermöglichen uns die Website zu optimieren.
				Informationen zu Ihrer Identität werden nicht erfasst. Die erhobenen Daten
				werden an einen Server von Microsoft in den USA übertragen und dort für
				grundsätzlich maximal 180 Tage gespeichert. Unter Umstanden kann Microsoft
				durch ein so genanntes Cross-Device-Tracking Ihr Nutzungsverhalten über
				mehrere Ihrer elektronischen Geräte verfolgen und ist so in der Lage,
				personifizierte Werbung auf bzw. in Microsoft-Websites und –Apps
				einzublenden. Weitere Informationen zum Datenschutz bei Microsoft finden
				Sie in den Datenschutzbestimmungen von Microsoft:
				https://privacy.microsoft.com/de-DE/privacystatement Die beschriebene
				Datenverarbeitung können Sie unter folgendem Link deaktivieren:
				https://account.microsoft.com/privacy/ad-settings Die Datenverarbeitung
				erfolgt gem. Art. 6 Abs. 1 lit. a DS-GVO.
			</Typography>
			<Typography variant="h2">Ihre Rechte</Typography>
			<Typography>
				Sofern be.storaged personenbezogene Daten zu Ihrer Person verarbeitet,
				erteilen wir Ihnen auf Verlangen Auskunft über die Kategorien der
				betroffenen Daten, die Verwendungszwecke, etwaige Empfänger oder
				Kategorien von Empfängern der Daten und der Dauer der geplanten
				Speicherung. Sie haben das Recht, die Berichtigung bzw. Ergänzung
				unrichtiger bzw. unvollständiger Daten zu verlangen. Sollte die
				Datenverarbeitung auf Grund einer von Ihnen erteilen Einwilligung
				erfolgen, haben sie das Recht, die Einwilligung mit Wirkung für die
				Zukunft jederzeit zu widerrufen. Sollte die Datenverarbeitung auf Grund
				eines berechtigten Interesses der be.storaged erfolgen, haben Sie das
				Recht, der Datenverarbeitung aus Gründen zu widersprechen, die sich aus
				Ihrer besonderen Situation ergeben (Art. 21 DS-GVO). Unter bestimmten
				Umständen haben Sie das Recht, die Löschung der Daten zu verlangen. Dieses
				insbesondere in den Fällen, in denen die Daten für die Datenverarbeitung
				nicht mehr erforderlich sind, Sie eine erteilte Einwilligung widerrufen
				haben oder auf Grund Ihrer besonderen Situation der Datenverarbeitung
				widersprochen haben. Sie können unter bestimmten Voraussetzungen die
				Einschränkung Ihrer personenbezogenen Daten verlangen, sofern eine
				Löschung nicht möglich bzw. die Löschpflicht streitig ist. Ferner haben
				Sie das Recht auf Datenübertragbarkeit. Das bedeutet, dass wir Ihnen Ihre
				Daten auf Antrag in einem maschinenlesbaren Format zur Verfügung stellen.
				Sie haben das Recht, sich bezüglich einer Beschwerde an die zuständige
				Aufsichtsbehörde zu wenden. Für Telekommunikationsdienstleistungen liegt
				die Zuständigkeit bei der Bundesbeauftragten für den Datenschutz und die
				Informationsfreiheit. Für alle anderen Anliegen ist die Landesbeauftragte
				für den Datenschutz Niedersachen zuständig.
			</Typography>
			<Typography variant="h2">An wen übermittelt be.storaged Daten</Typography>
			<Typography>
				be.storaged übermittelt Ihre Daten gem. Art. 28 DS-GVO an
				Auftragsverarbeiter. Ihre Daten werden beim Auftragsverarbeiter nur im
				gesetzlichen Rahmen und nach Weisung der be.storaged verarbeitet.
				Verantwortlich für die Datenverarbeitung beim Auftragsverarbeiter ist die
				be.storaged. Für die Leistungserbringung übermittelt be.storaged ggf. Ihre
				Daten an Kooperationspartner. Dieses erfolgt entweder auf Grund einer
				gesetzlichen Zulässigkeit, oder sofern Sie uns hierzu Ihre Einwilligung
				erteilt haben. Ferner sind wir in bestimmten Fällen verpflichtet, Ihre
				Daten an behördliche Stellen zu übermitteln.
			</Typography>
			<Typography variant="h2">
				Bestehen einer automatisierten Entscheidungsfindung im Einzelfall
				(einschließlich Profiling)
			</Typography>
			<Typography>
				Wir setzen keine rein automatisierten Entscheidungsverfahren gemäß Artikel
				22 DSGVO ein. Sofern wir ein solches Verfahren zukünftig in Einzelfällen
				doch einsetzen sollten, werden wir Sie hierüber gesondert informieren,
				sofern dies gesetzlich vorgeben ist.
			</Typography>
			<Typography variant="h2">Sicherheitsmassnahme</Typography>
			<Typography>
				be.storaged setzt umfangreiche technische und organisatorische
				Sicherheitsmaßnahmen ein, um Ihre bei uns verwalteten personenbezogenen
				Daten gegen Missbrauch, zufällige oder vorsätzliche Manipulationen oder
				gegen den Zugriff unberechtigter Personen zu schützen. Unsere
				Sicherheitsverfahren werden entsprechend der technologischen Entwicklung
				fortlaufend verbessert.
			</Typography>
			<Typography variant="h2">
				Name und Anschrift des Datenschutzbeauftragten
			</Typography>
			<Typography>Datenschutzbeauftragter:</Typography>
			<Typography>be.storaged GmbH</Typography>
			<Typography>Tirpitzstraße 39</Typography>
			<Typography>26122 Oldenburg</Typography>
			<Typography>E-Mail: info@be-storaged.com</Typography>
			<Typography>
				<a
					href="http://www.be-storaged.com"
					target="_blank"
					rel="noopener noreferrer"
				>
					http://www.be-storaged.com
				</a>
			</Typography>
			<Typography variant="h2">Widerrufsbelehrung für Verbraucher</Typography>
			<Typography variant="h4">Widerrufsrecht</Typography>
			<Typography>
				Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen einen
				online-geschlossenen Vertrag zu widerrufen. Die Widerrufsfrist beträgt
				vierzehn Tage ab dem Tag des Vertragsschlusses. Um Ihr Widerrufsrecht
				auszuüben, müssen Sie uns, be.storaged GmbH, Donnerschweer Str. 22 -26,
				26123 Oldenburg, E-Mail-Adresse: info@be-storaged.com mittels einer
				eindeutigen Erklärung (z.B. ein mit der Post versandter Brief, Telefax
				oder E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
				informieren. Sie können das Muster-Widerrufsformular oder eine andere
				eindeutige Erklärung auf unserer Webseite http://www.be-storaged.com
				elektronisch ausfüllen und übermitteln. Machen Sie von dieser Möglichkeit
				Gebrauch, so werden wir Ihnen unverzüglich (z.B. per E-Mail) eine
				Bestätigung über den Eingang eines solchen Widerrufs übermitteln. Zur
				Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die
				Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
			</Typography>
			<Typography variant="h2">FOLGEN DES WIDERRUFS</Typography>
			<Typography>
				Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
				wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
				Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine
				andere Art der Lieferung als die von uns angebotene, günstigste
				Standardlieferung gewählt haben), unverzüglich und spätestens binnen
				vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren
				Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung
				verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
				Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich
				etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser
				Rückzahlung Entgelte berechnet. Haben Sie verlangt, dass die
				Dienstleistung während der Widerrufsfrist beginnen soll, so haben Sie uns
				einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem
				Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts
				hinsichtlich dieses Vertrags unterrichten, bereits erbrachten
				Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen
				Dienstleistungen entspricht.
			</Typography>
		</CardWrapper>
	</Root>
);

export default PagePrivacy;
